import { call, put, takeLatest, all } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import * as Constants from './constants'
import * as Actions from './actions'

const addRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/addnewquestion`;
const editRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/editquestion`;
const getRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/get-question-data`;
const ownerRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/getownerslist`;

// SQL questions live in sql_questions_staging with per-schema expected results,
// so they use their own endpoints instead of the shared `questions` ones.
const sqlAddRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/sql/add-question`;
const sqlEditRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/sql/edit-question`;
const sqlGetRequestUrl = `${process.env.REACT_APP_WEB_API}/api/v1/assessments/sql/get-question`;

// BASH questions
const bashAddQuestionUrl = `${process.env.REACT_APP_WEB_API}/api/v1/bash/add-question`;
const bashGetQuestionUrl = `${process.env.REACT_APP_WEB_API}/api/v1/bash/get-question`;
const bashEditQuestionUrl = `${process.env.REACT_APP_WEB_API}/api/v1/bash/edit-question`;

function postJson (url, body) {
  return fetch(url, {
    method: 'POST',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body),
  })
}

function handleRequest (request) {
  return request
    .then((response) => response.json())
    .then((json) => {
      if (json && json.meta && json.meta.code !== 200) {
        throw new Error(json.meta.message || 'Request failed')
      }
      return json
    })
    .catch((error) => { throw error })
}

function addRequestApi ({ data, pageMode }) {
  const isEdit = pageMode === 'edit'
  const isSql = data && data.question_type_code === 'SQL'
  const isBash = data && data.question_type_code==='BASH'

  let url
  if(isBash) url = isEdit ? bashEditQuestionUrl : bashAddQuestionUrl;
  else if (isSql) url = isEdit ? sqlEditRequestUrl : sqlAddRequestUrl
  else url = isEdit ? editRequestUrl : addRequestUrl

  return handleRequest(postJson(url, data))
}
function* addRequestFlow (action) {
  try {
    const result = yield call(addRequestApi, action)
    yield put(Actions.addSuccess(result))
  } catch (error) {
    yield put(Actions.addError(error))
  }
}

/**
 * The edit route only carries a question id, so the type is unknown until the
 * question is loaded. Try the shared question bank first, then the SQL and BASH
 * ones, which store their questions in separate tables.
 */
async function getRequestApi ({ questionId }) {
  try {
    const result = await handleRequest(postJson(getRequestUrl, { question_id: questionId }))
    if (result && result.data && result.data.length > 0) return result
  } catch (error) {
    // not in the shared question bank — fall through to SQL
  }

  try {
    const sqlResult = await handleRequest(postJson(sqlGetRequestUrl, { question_id: questionId }))

    // Normalise to the array shape the container hydrates from.
    return {
      ...sqlResult,
      data: [{ ...sqlResult.data, question_type_code: 'SQL' }],
    }
  } catch (error) {
    // not a SQL question — fall through to BASH
  }

  const bashResult = await handleRequest(postJson(bashGetQuestionUrl, { question_id: questionId }))
  return {
    ...bashResult,
    data: [bashResult.data],
  }
}
function* getRequestFlow (action) {
  try {
    const result = yield call(getRequestApi, action)
    yield put(Actions.getSuccess(result))
  } catch (error) {
    yield put(Actions.getError(error))
  }
}

function ownerRequestApi ({ owner }) {
  const request = fetch(`${ownerRequestUrl}?owners=${owner}`, {
    method: 'GET',
    headers: {
      authorization: localStorage.getItem("jwtToken"),
      'Content-Type': 'application/json'
    },
  })

  return handleRequest(request)
}
function* ownerRequestFlow (action) {
  try {
    const result = yield call(ownerRequestApi, action)
    yield put(Actions.ownerSuccess(result))
  } catch (error) {
    yield put(Actions.ownerError(error))
  }
}

function* questionWatcher () {
  yield all([
    takeLatest(Constants.ADD_REQUEST, addRequestFlow),
    takeLatest(Constants.GET_REQUEST, getRequestFlow),
    takeLatest(Constants.OWNER_REQUEST, ownerRequestFlow),
  ])
}

export default questionWatcher
